import * as Thrift from 'thrift';
import { TTransport } from 'thrift';

import { TAppContact } from 'TProtocol/common/models';

class TMyTransport extends Thrift.TBufferedTransport {
  buf: Buffer;

  constructor(buffer: Buffer) {
    super(buffer);
    this.buf = buffer;
  }

  write(buf: Buffer) {
    super.write(buf);
    this.buf = buf;
  }
}

export default class ThriftSerializer {
  static serialize(contact: TAppContact) {
    const transport = new TMyTransport(new Buffer(''));
    const protocol = new Thrift.TJSONProtocol(transport);
    protocol.writeMessageBegin('', Thrift.Thrift.MessageType.REPLY, 0);
    contact.write(protocol);
    protocol.writeMessageEnd();
    protocol.flush();
    return transport.buf;
  }

  static deserialize(buf: Buffer): TAppContact | undefined {
    let deserializedContact;
    const callback = (reader: TTransport) => {
      const protocol = new Thrift.TJSONProtocol(reader);
      protocol.readMessageBegin();
      deserializedContact = TAppContact.read(protocol);
      protocol.readMessageEnd();
    };
    const transport = Thrift.TBufferedTransport.receiver(callback, 0);
    transport(new Buffer(buf));
    if (deserializedContact) {
      return deserializedContact;
    }
    return undefined;
  }
}
